/* import __COLOCATED_TEMPLATE__ from './set-ticket-custom-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();